import React, { useState } from 'react';
import { contact } from '../data/company';
import Reveal from '../components/Reveal';
import Icon from '../components/Icon';

const empty = { first: '', last: '', email: '', phone: '', message: '' };

export default function ContactPage() {
  const [f, setF] = useState(empty);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const mail = contact.email;

  // Static site: opens the visitor's email app with the message filled in.
  const submit = (e) => {
    e.preventDefault();
    const body = `Name: ${f.first} ${f.last}\nEmail: ${f.email}\nPhone: ${f.phone}\n\n${f.message}`;
    window.location.href = `mailto:${mail}?subject=${encodeURIComponent('Website enquiry')}&body=${encodeURIComponent(body)}`;
  };

  const rows = [
    ['phone', contact.phone],
    ['mail', contact.email],
    ['pin', `Office: ${contact.address}`],
    ['building', `Head Office: ${contact.headOffice}`],
    ['clock', contact.hours],
  ];

  return (
    <section className="cpage">
      <div className="container">
        <Reveal className="cpage__head">
          <h1>Contact Us</h1>
          <p>Any question or remarks? Just write us a message!</p>
        </Reveal>

        <div className="cgrid">
          <Reveal>
            <aside className="cinfo">
              <h2>Contact Information</h2>
              <p>Say something to start a live chat!</p>
              <ul>
                {rows.map(([icon, text]) => (<li key={icon}><Icon name={icon} size={18} /><span>{text}</span></li>))}
              </ul>
              <span className="cinfo__dot" aria-hidden="true" />
            </aside>
          </Reveal>

          <Reveal delay={100}>
            <form className="cform" onSubmit={submit}>
              <label>First Name<input required placeholder="Enter first name" value={f.first} onChange={set('first')} autoComplete="given-name" /></label>
              <label>Last Name<input required placeholder="Enter last name" value={f.last} onChange={set('last')} autoComplete="family-name" /></label>
              <label>Email<input required type="email" placeholder="Enter email address" value={f.email} onChange={set('email')} autoComplete="email" /></label>
              <label>Phone Number<input type="tel" placeholder="Enter phone number" value={f.phone} onChange={set('phone')} autoComplete="tel" /></label>
              <label className="cform__full">Message<textarea rows="3" placeholder="Write your message." value={f.message} onChange={set('message')} /></label>
              <div className="cform__send cform__full">
                <svg viewBox="0 0 120 70" width="110" height="64" aria-hidden="true">
                  <path d="M6 66c10-34 36-30 52-14 14 14 34 8 44-22" fill="none" stroke="#fff" strokeOpacity=".5" strokeDasharray="3 4" />
                  <path d="M104 6l12 22-22-4-8 8 4-16z" fill="#fff" />
                </svg>
                <button className="btn btn--pillsend" type="submit">Send Message</button>
              </div>
              <p className="cform__note cform__full">Sending opens your email app with these details filled in.</p>
            </form>
          </Reveal>
        </div>

        {contact.mapEmbedUrl && (
          <Reveal className="cmap">
            <iframe title="SDL location" src={contact.mapEmbedUrl} loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
            {contact.mapLink && (
              <a className="btn btn--primary cmap__link" href={contact.mapLink} target="_blank" rel="noopener noreferrer">
                Open in Google Maps <Icon name="arrow" size={16} />
              </a>
            )}
          </Reveal>
        )}
      </div>
    </section>
  );
}
